<template>
<div class="form">
<a-card :title="c_title">
    <v-gobackbutton slot="extra" >返回</v-gobackbutton>
    <a-card-grid style="width:100%;text-align:left" :hoverable="false">
    <p class="form_sub_title">基础信息</p>
    <label class="form_lable">角色编码：</label><span class="form_value">{{roleData.code}}</span>
    <br />
    <br />
    <label class="form_lable">角色名称：</label><span class="form_value">{{roleData.name}}</span>
    <br />
    <br />
    <label class="form_lable">有效性：</label><span class="form_value">{{roleData.iseffective == '1' ? '有效':'无效'}}</span>
    <br />
    <br />
    <label class="form_lable">说明：</label><span class="form_value">{{roleData.remark}}</span>
    <br />
     </a-card-grid>

     <a-card-grid style="width:100%;text-align:left;-webkit-box-shadow:none;padding-bottom:10px;" :hoverable="false">
        <span class="form_sub_title">角色用户信息</span>
        <a-button type="primary" @click="handleSelectUser" style="margin-left:20px;">
            选择用户
        </a-button>

    </a-card-grid>
        <a-card-grid style="width:50%;;-webkit-box-shadow:none;padding:10px;" :hoverable="false">
            <a-divider>待授权用户</a-divider>
            <a-input-group compact style="margin-bottom:10px;">
                <a-select default-value="zname" @change="onSearchChange_a">
                    <a-select-option value="zname">
                    {{name_title}}
                    </a-select-option>
                    <a-select-option value="zcode">
                    {{code_title}}
                    </a-select-option>
                </a-select>
                <a-input-search v-model="searchVal_a" style="width: 50%" default-value=""  @search="dosearchA" />
            </a-input-group>
            <a-table :columns="columns_selected" :data-source="tableDataA"  :pagination="true" :loading="tLoading_a" rowKey="usercode" >
                <span slot="orgName" slot-scope="text">{{ text }}</span>
                <template slot="operation" slot-scope="text, record">
                    <div class="editable-row-operations">
                    <span style="margin-left:15px;">
                            <a-popconfirm  @confirm="() => onSelectedDelete(record)" >
                                <template slot="title">
                                    <p>{{ '确认将【' + record.fullname+ '】删除？' }}</p>
                                </template>
                            <a>删除</a>
                            </a-popconfirm>
                        </span>
                    </div>
                </template>
            </a-table>
            <br />
        </a-card-grid>
    
        <a-card-grid style="width:50%;-webkit-box-shadow:none;padding:10px;" :hoverable="false">
             <a-divider>已授权用户</a-divider>
             <a-input-group compact style="margin-bottom:10px;">
                <a-select default-value="zname" @change="onSearchChange">
                    <a-select-option value="zname">
                    {{name_title}}
                    </a-select-option>
                    <a-select-option value="zcode">
                    {{code_title}}
                    </a-select-option>
                </a-select>
                <a-input-search style="width: 50%" default-value=""  @search="onSearchS" />
            </a-input-group>
            <a-table :columns="columns_selected" :data-source="autheduser"  :pagination="false" :loading="tLoading" rowKey="usercode" >
                <span slot="orgName" slot-scope="text">{{ text }}</span>
                <template slot="operation" slot-scope="text, record">
                    <div class="editable-row-operations">
                    <span style="margin-left:15px;">
                            <a-popconfirm  @confirm="() => onAlreadyDelete(record)" >
                                <template slot="title">
                                    <p>{{ '确认将【' + record.fullname+ '】删除？' }}</p>
                                </template>
                            <a>删除</a>
                            </a-popconfirm>
                        </span>
                    </div>
                </template>
            </a-table>
            <br />
            <a-pagination v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper style="float:right;" />
        </a-card-grid>
        
    <br />
    <br />
     <a-card-grid style="width:100%;text-align:center;border:none;-webkit-box-shadow:none;" :hoverable="false" >
    <a-button type="primary" @click="handleOk">
        保存并授权
    </a-button>
    <a-button style="margin-left: 10px;" @click="handleCancel">
        取消
    </a-button>
    </a-card-grid>
    <userselect ref="userselect2"  @onModalHide="handleModalHideUser"></userselect>
</a-card>
</div>
  
</template>
<script>
// code: "0010"
// id: "10"
// iseffective: "1"
// menus: "1,22,752,20,18"
// name: "色色色涩"
// remark: "12343"
// systemrole: "0"
import userselect from '../orgmanage/userselect'
const columns_selected = [
    {
        title: '用户编码',
        dataIndex: 'usercode',
        align: 'left',
    },
    {
        title: '用户姓名',
        dataIndex: 'fullname',
        align: 'left',
        ellipsises:true
    },
    {
        title: '组织名称',
        dataIndex: 'organizationname',
        scopedSlots: { customRender: 'orgName' },
        align: 'left',
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    }

];
export default {

    data() {
        return {
            c_title:'',
            roleid:'',
            roleData:{},
            //已授权用户
            tLoading:false,
            columns_selected:columns_selected,
            autheduser:[],
            name_title:'用户姓名',
            code_title:'用户编码',
            pagination:{
                total:0,
                pageSize:0,
                current:1,
            },
            searchVal:'',
            searchKey:'zname',
            //待授权用户
            tLoading_a:false,
            autheduser_a:[],
            searchVal_a:'',
            searchKey_a:'zname',
            tableDataA:[],
        };
    },
    components:{
        userselect
    },
   
    methods: {
        dosearchA(){
            let searchVal_ = this.searchVal_a;
            let searchKey_ = this.searchKey_a;
            if(!searchVal_){
                this.tableDataA = this.autheduser_a
                return;
            }
            if(searchKey_== 'zname'){
                this.tableDataA = this.autheduser_a.filter(function(n){
                    return n.fullname.indexOf(searchVal_) != -1
                });
            }
            else if(searchKey_ == 'zcode'){
                this.tableDataA = this.autheduser_a.filter(function(n){
                    return n.usercode.indexOf(searchVal_) != -1
                });
            }
            
        },
        handleModalHideUser(result){
            if(!result){
                return
            }
            console.log(result)
            this.autheduser_a = result;

            this.dosearchA()

        },
        onSelectedDelete(record){
            this.autheduser_a = this.autheduser_a.filter(function(n){
                return n.usercode != record.usercode
            });
            this.tableDataA = this.autheduser_a;
            this.$refs.userselect2.handleDeleteSelect(record.usercode)
        },
        onAlreadyDelete(record){
            // this.autheduser 
            this.$store
                .dispatch({
                    type: "rolecenter/deleteAuthUser",
                    params: {userid:record.userid,roleid:this.roleid}
                })
            this.autheduser = this.autheduser.filter(function(n){
                return n.usercode != record.usercode
            }); 
        },
        handleOk() {
            let c_params = [];
            this.autheduser_a.forEach(element => {
                c_params.push(element.userid)
            });
            if(c_params.length == 0){
                this.message.warning('请选择用户！');
                return;
            }
            this.$store
                .dispatch({
                    type: "rolecenter/authUser",
                    params: {userId:c_params.join(','),roleid:this.roleid}
                })
                .then((response) => {
                    console.log(response)
                    this.handleCancel();
                });
        },
        handleSelectUser(){
            this.$refs.userselect2.onModalInit(1,'1');
        },
        handleCancel() {
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
        handlePageChange(c_p){
            this.getAuthedUser(this.roleid,c_p)
        },
        onSearchS(value){
            this.searchVal = value;
            this.getAuthedUser(this.roleid,1);
        },

        onSearchChange(value){
            this.searchKey = value;
        },
        onSearchChange_a(value){
            this.searchKey_a = value;
        },
        getAuthedUser(roleid,cpage){
            this.roleid = roleid;
            let c_params = {
                roleid:roleid,
                urlparams:false,
                type:'1',
                page:cpage
            }
            if(this.searchKey == 'zname'){
                c_params.fullname = this.searchVal
            }
            else{
                c_params.usercode = this.searchVal
            }
            this.$store.dispatch({
                type: "rolecenter/selectAuthUser",
                params: c_params,
                showMsg: false,
            }).then((res)=>{
                this.tLoading = false;
                let result = res.data.data;
                this.autheduser = result.list;
                this.pagination.total = result.totalRecords;
                this.pagination.pageSize = result.pageSize;
                this.pagination.current = result.page;
            })
        }
       
    },
    computed: {
       
    },
    mounted(){
        const { query } = this.$route;
        this.c_title = "角色授权"
        this.$store.dispatch({
            type: "rolecenter/getRole",
            params: query,
            showMsg: false
        }).then((res)=>{
            this.roleData = res.data.data;
            this.getAuthedUser(this.roleData.id,1)
        })
        
    }
};
</script>

<style scoped>
    .form_sub_title{
        font-weight: bold;
        font-size: 16px;
    }
    .form_lable{
        width:100px;
        font-size: 14px;
        display: inline-block;
        margin-left: 10px;
        color: rgba(0, 0, 0, 0.65);
    }
    .form_value{
        font-size: 14px;
        margin-left: 40px;
        color: rgba(0, 0, 0, 0.65);
    }
</style>
